import React from 'react';
import moment from 'moment'

const ShowUserProjects = ({projects, profile }) => {

    return (
        <div>
            {projects?.map((project, index)=>{
                return(
                    <div
                    key={index}
                    className="bg-gray-50 rounded-lg"
                    style={{marginBottom: '10px'}}
                    >
                        <div className="px-4 py-5 sm:p-6">
                            <p 
                            style={{
                                fontWeight: 700,
                                fontSize: 15,
                                marginBottom: '5px'
                            }}
                            >
                                {project?.ProspectName}
                            </p>
                            <p 
                            className="whitespace-normal"
                            >
                                {project?.ProspectContent}
                            </p>
                            <p className="text-sm text-gray-500 truncate mt-2">
                                {project?.CreatedAt ? 
                                    <span>{moment(project?.CreatedAt?.toDate()).calendar()}</span>
                                :
                                    <span>{moment(project?.createdAt?.toDate()).calendar()}</span>
                                }
                            </p>
                        </div>  
                    </div>
                )
            })}
            
        </div>
    )
}

export default ShowUserProjects
